import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Divider from '@mui/material/Divider'
import irdai from 'src/assets/Buy_Policy_Images/IRDAI.svg'
import GreyInfoIcon from 'src/assets/Buy_Policy_Images/GreyInfoIcon.svg'
import { Box, Card, Checkbox, Tooltip } from '@mui/material'
import FormControlLabel from '@mui/material/FormControlLabel'
import { MOTOR_PLAN_DETAILS } from 'src/utils/constants/BuyPolicyMotor'
import ContactUs from 'src/components/BuyPolicy/insuranceScreens/health/ContactUs'
import { useDispatch, useSelector } from 'react-redux'
import { updateCurrentPolicyDetailsMotor } from 'src/actions'
import { POLICY_TYPES } from 'src/utils/constants/BuyPolicy'

const InsuranceCoverMenu = ({ addOnsList }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const motorDetails = useSelector((state) => state?.buyPolicyMotorReducer)
  const currentPolicyDetails = motorDetails?.currentPolicyDetails
  const [paCover, setPACover] = useState(currentPolicyDetails?.paCover)
  const [selectedAddOns, setSelectedAddOns] = useState(
    currentPolicyDetails ? currentPolicyDetails?.selectedAddOns : []
  )
  const [selectedAddOnIds, setSelectedAddOnIds] = useState(
    currentPolicyDetails ? currentPolicyDetails?.addOns : []
  )
  const [showAllAddOns, setShowAllAddOns] = useState(false)

  const handlePACover = () => {
    setPACover(!paCover)
  }

  const handleCheck = (motor) => {
    if (selectedAddOnIds.includes(motor?.id)) {
      setSelectedAddOnIds(selectedAddOnIds?.filter((id) => id !== motor?.id))
      setSelectedAddOns(
        selectedAddOns?.filter(
          (selectedMotor) => selectedMotor?.id !== motor?.id
        )
      )
    } else {
      setSelectedAddOnIds([...selectedAddOnIds, motor?.id])
      setSelectedAddOns([...selectedAddOns, motor])
    }
  }

  const handleShowAllAddOns = () => {
    setShowAllAddOns(true)
  }
  const handleShowLessAddOns = () => {
    setShowAllAddOns(false)
  }
  const sliceAddOnList = (addOnsList, showAllAddOns, length) => {
    if (addOnsList) {
      return addOnsList?.slice(0, showAllAddOns ? addOnsList?.length : length)
    } else return []
  }

  useEffect(() => {
    dispatch(
      updateCurrentPolicyDetailsMotor({
        ...currentPolicyDetails,
        paCover: paCover,
        addOns: selectedAddOnIds,
        selectedAddOns: selectedAddOns,
      })
    )
    // eslint-disable-next-line
  }, [paCover, selectedAddOnIds, selectedAddOns])

  return (
    <>
      <Card className={classes.coveragesCard}>
        {currentPolicyDetails?.policyType !== POLICY_TYPES?.OWN_DAMAGE ? (
          <Box className={classes.coveragesContent}>
            <Box className={classes.dividerContent}>
              <Divider className={classes.dividerLine}>DEFAULT COVER</Divider>
            </Box>
            <Box className={classes.infoContent}>
              {MOTOR_PLAN_DETAILS?.map((motor) => {
                return (
                  <Box
                    className={classes.motorContent}
                    key={`motorDetails_${motor?.title}`}
                  >
                    <Box className={classes.motorContentOne}>
                      <FormControlLabel
                        value={paCover}
                        control={
                          <Checkbox
                            id='paCoverCheckbox'
                            size='small'
                            checked={paCover ? true : false}
                          />
                        }
                        label={
                          <Box className={classes.label}>{motor?.title}</Box>
                        }
                        onChange={handlePACover}
                      />
                      <Tooltip
                        title={
                          <>
                            <Box>
                              <b>Personal Accident (PA) Cover</b>
                            </Box>
                            <Box>
                              As per the IRDAI (Insurance Regulatory and
                              Development Authority of India) notice, PA Cover
                              is mandatory for individually-owned cars if they
                              don&apos;t have an existing 15 Lakhs PA Cover.
                            </Box>
                            <br />
                            <Box>
                              <b>Opt for it unless...</b>
                            </Box>
                            <Box>
                              1. Car registered under a company&apos;s name
                            </Box>
                            <Box>
                              2. You already have a 15 lakhs PA Cover from
                              another vehicle or a standalone policy.
                            </Box>
                            <br />
                            <Box>
                              PA Cover provides 15 lakhs in case of death or
                              disability due to an accident for the car owner or
                              nominee.
                            </Box>
                          </>
                        }
                        arrow
                      >
                        <img src={GreyInfoIcon} className={classes.infoImage} />
                      </Tooltip>
                    </Box>
                  </Box>
                )
              })}
              <Box className={classes.imageContainer}>
                {/* <Box className={classes.imageContent}> */}
                <Box className={classes.imageOne}>
                  <img src={irdai} alt='IRDAI' className={classes.irdaiImage} />
                  <span className={classes.mandateContent}>
                    Mandate by IRDAI
                  </span>
                </Box>
                <Box className={classes.paraContent}>
                  <span className={classes.paragraph}>what is this?</span>
                </Box>
              </Box>
              <Box className={classes.deselectText}>
                Deselect if you already have
              </Box>
            </Box>
          </Box>
        ) : null}
        <Box className={classes.chooseContainer}>
          <Box className={classes.chooseContent}>
            <Divider>CHOOSE</Divider>
          </Box>
          <Box className={classes.featureContext}>
            {sliceAddOnList(addOnsList, showAllAddOns, 5)?.map((motor) => {
              return (
                <Box
                  className={classes.featureContent}
                  key={`feature_${motor?.title}`}
                >
                  <Box className={classes.featureChecklist}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          id='motorCheckbox'
                          className={classes.checkList}
                          size='small'
                          checked={selectedAddOnIds?.includes(motor?.id)} // Check based on whether the ID is in the selectedAddOnIds array
                          onChange={() => handleCheck(motor)} // Call handleCheck function with the motor object
                        />
                      }
                      label={
                        <Tooltip
                          placement='right-start'
                          arrow
                          title={
                            motor?.description ? (
                              <>
                                <Box>{motor?.description}</Box>
                              </>
                            ) : null
                          }
                        >
                          <Box className={classes.checkTitle}>
                            {motor?.coverage}
                          </Box>
                        </Tooltip>
                      }
                    />
                  </Box>
                </Box>
              )
            })}
          </Box>
          {addOnsList?.length > 5 && !showAllAddOns && (
            <Box
              className={classes.viewOptionsContainer}
              onClick={handleShowAllAddOns}
              id='viewMore'
            >
              <span className={classes.viewContent}>View more options</span>
            </Box>
          )}
          {showAllAddOns && (
            <Box
              className={classes.viewOptionsContainer}
              onClick={handleShowLessAddOns}
              id='viewLess'
            >
              <span className={classes.viewContent}>View less options</span>
            </Box>
          )}
        </Box>
        <Box className={classes.contactUs}>
          <ContactUs />
        </Box>
      </Card>
    </>
  )
}

export default InsuranceCoverMenu

const useStyles = makeStyles({
  coveragesContent: {
    display: 'flex',
    flexDirection: 'Column',
    justifyContent: 'center',
    padding: '40px 30px 0px 40px',
  },
  coveragesCard: {
    border: '6px',
    borderRadius: '10px !important',
    background: 'white',
    boxShadow: '0px 4px 7px 0px #0000001A',
    marginTop: '6px',
  },
  dividerContent: {
    fontSize: '12px',
    fontWeight: '500',
    color: '#E45C91',
  },
  chooseContent: {
    fontSize: '12px',
    fontWeight: '500',
    color: '#707070',
    marginBottom: '-5px',
  },
  label: {
    fontSize: '14px !important',
    fontWeight: '500',
  },
  motorContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    boxSizing: 'border-box',
    background: '#E9E9E9',
    padding: '10px 10px',
    borderRadius: '8px',
  },
  imageOne: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  mandateContent: {
    fontSize: '13px',
    fontFamily: '500',
    color: '#2E3192',
    width: '65%',
  },
  paragraph: {
    fontSize: '12px',
    fontFamily: '400',
    color: '#2E3192',
  },
  irdaiImage: {
    width: '20%',
  },
  paraContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  checkList: {
    color: '#A4BDC3',
  },
  checkTitle: {
    fontSize: '14px',
    fontWeight: '500',
    textAlign: 'left',
    lineHeight: '16.41px',
  },
  featureSpanContent: {
    fontSize: '12px',
    fontWeight: '400',
    color: '#7A7A7A',
  },
  featureContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  featureActions: {
    paddingLeft: '9%',
    marginTop: '-5%',
  },
  featureChecklist: {
    paddingTop: '1%',
  },
  viewContent: {
    fontSize: '14px !important',
    fontWeight: '500',
    textAlign: 'center !important',
    color: '#379FBB',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  viewOptionsContainer: {
    padding: '6% 1% 8% 28%',
  },
  chooseContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '20px 40px 20px 40px',
  },
  dividerLine: {
    '&::before, &::after': {
      borderColor: '#E76396 !important',
    },
  },
  deselectText: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '14px',
    letterSpacing: '0em',
    color: '#565656',
    display: 'flex',
    justifyContent: 'center',
    padding: 5,
  },
  infoImage: {
    marginLeft: '-10px',
  },
  motorContentOne: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  featureContext: {
    marginLeft: '-10px',
  },
  contactUs: { padding: '0px 2px' },
})
